import { z } from 'zod';
import { UserRole } from '../types/enums.js';
export const loginSchema = z.object({
    email: z.string().email(),
    password: z.string().min(8).max(200),
});
export const createUserSchema = z.object({
    email: z.string().email(),
    name: z.string().min(1).max(120),
    password: z.string().min(8).max(200),
    role: z.nativeEnum(UserRole),
    active: z.boolean().default(true),
    scopedCustomerIds: z.array(z.string().uuid()).default([]),
    scopedProjectIds: z.array(z.string().uuid()).default([]),
    scopedAgencyCode: z.string().nullable().optional(),
    workerId: z.string().uuid().nullable().optional(),
    contactId: z.string().uuid().nullable().optional(),
});
export const updateUserSchema = createUserSchema.partial();
export const inviteUsersSchema = z.object({
    invites: z.array(z.object({
        email: z.string().email(),
        name: z.string().min(1).max(120),
        role: z.nativeEnum(UserRole),
        workerId: z.string().uuid().nullable().optional(),
    })).min(1).max(200),
});
export const acceptInviteSchema = z.object({
    token: z.string().min(10),
    password: z.string().min(8).max(200),
});
//# sourceMappingURL=auth.js.map